export class ListRequest {
  index: number = 1;
  size: number = 30;
  option?: any;
}



// WEBPACK FOOTER //
// ./src/app/view-model/internal/listrequest.ts